import React, { useEffect } from "react";
import { Flex } from "antd";
import { useTenantLogos, getLogoForMode } from "../../../hooks/tenant";
import { useColorMode } from "../../../contexts/color-mode";

export const PageTitle: React.FC = () => {
    const { logos } = useTenantLogos();
    const { mode } = useColorMode();

    useEffect(() => {
        console.log("logos", logos);
    }, [logos]);
    
    const tenantLogo = getLogoForMode(logos, mode as 'light' | 'dark');

    return (
        <Flex
            align="center"
            justify="center"
            className="mb-16">
            <img 
                src={tenantLogo || `/images/logo-${mode}.png`}
                alt="Logo" 
                style={{ 
                    width: tenantLogo ? "auto" : "150px",
                    maxWidth: "200px",
                    maxHeight: "80px",
                    objectFit: "contain"
                }} 
            />
        </Flex>
    );
};